// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__h7yiX","text":"styles_text__QKBS3"};